import React from 'react';

export default function MetricsContainer({ metrics }) {
  return <div className="grid lg:grid-cols-3 gap-4 w-full mt-md">{metrics}</div>;
}
